// ISO-3166-1 alpha-2 country codes with English+Russian names and flag emoji.
// Used by RegisterPage, ProfilePage, Leaderboard.
// Flag emoji is computed from ISO code via unicode regional indicators.

export const COUNTRIES = [
  ["AF", "Afghanistan", "Афганистан"],
  ["AL", "Albania", "Албания"],
  ["DZ", "Algeria", "Алжир"],
  ["AD", "Andorra", "Андорра"],
  ["AO", "Angola", "Ангола"],
  ["AG", "Antigua and Barbuda", "Антигуа и Барбуда"],
  ["AR", "Argentina", "Аргентина"],
  ["AM", "Armenia", "Армения"],
  ["AU", "Australia", "Австралия"],
  ["AT", "Austria", "Австрия"],
  ["AZ", "Azerbaijan", "Азербайджан"],
  ["BS", "Bahamas", "Багамы"],
  ["BH", "Bahrain", "Бахрейн"],
  ["BD", "Bangladesh", "Бангладеш"],
  ["BB", "Barbados", "Барбадос"],
  ["BY", "Belarus", "Беларусь"],
  ["BE", "Belgium", "Бельгия"],
  ["BZ", "Belize", "Белиз"],
  ["BJ", "Benin", "Бенин"],
  ["BT", "Bhutan", "Бутан"],
  ["BO", "Bolivia", "Боливия"],
  ["BA", "Bosnia and Herzegovina", "Босния и Герцеговина"],
  ["BW", "Botswana", "Ботсвана"],
  ["BR", "Brazil", "Бразилия"],
  ["BN", "Brunei", "Бруней"],
  ["BG", "Bulgaria", "Болгария"],
  ["BF", "Burkina Faso", "Буркина-Фасо"],
  ["BI", "Burundi", "Бурунди"],
  ["CV", "Cabo Verde", "Кабо-Верде"],
  ["KH", "Cambodia", "Камбоджа"],
  ["CM", "Cameroon", "Камерун"],
  ["CA", "Canada", "Канада"],
  ["CF", "Central African Republic", "ЦАР"],
  ["TD", "Chad", "Чад"],
  ["CL", "Chile", "Чили"],
  ["CN", "China", "Китай"],
  ["CO", "Colombia", "Колумбия"],
  ["KM", "Comoros", "Коморы"],
  ["CG", "Congo", "Конго"],
  ["CD", "Congo (DRC)", "ДР Конго"],
  ["CR", "Costa Rica", "Коста-Рика"],
  ["CI", "Côte d'Ivoire", "Кот-д’Ивуар"],
  ["HR", "Croatia", "Хорватия"],
  ["CU", "Cuba", "Куба"],
  ["CY", "Cyprus", "Кипр"],
  ["CZ", "Czechia", "Чехия"],
  ["DK", "Denmark", "Дания"],
  ["DJ", "Djibouti", "Джибути"],
  ["DM", "Dominica", "Доминика"],
  ["DO", "Dominican Republic", "Доминиканская Республика"],
  ["EC", "Ecuador", "Эквадор"],
  ["EG", "Egypt", "Египет"],
  ["SV", "El Salvador", "Сальвадор"],
  ["GQ", "Equatorial Guinea", "Экваториальная Гвинея"],
  ["ER", "Eritrea", "Эритрея"],
  ["EE", "Estonia", "Эстония"],
  ["SZ", "Eswatini", "Эсватини"],
  ["ET", "Ethiopia", "Эфиопия"],
  ["FJ", "Fiji", "Фиджи"],
  ["FI", "Finland", "Финляндия"],
  ["FR", "France", "Франция"],
  ["GA", "Gabon", "Габон"],
  ["GM", "Gambia", "Гамбия"],
  ["GE", "Georgia", "Грузия"],
  ["DE", "Germany", "Германия"],
  ["GH", "Ghana", "Гана"],
  ["GR", "Greece", "Греция"],
  ["GD", "Grenada", "Гренада"],
  ["GT", "Guatemala", "Гватемала"],
  ["GN", "Guinea", "Гвинея"],
  ["GW", "Guinea-Bissau", "Гвинея-Бисау"],
  ["GY", "Guyana", "Гайана"],
  ["HT", "Haiti", "Гаити"],
  ["HN", "Honduras", "Гондурас"],
  ["HK", "Hong Kong", "Гонконг"],
  ["HU", "Hungary", "Венгрия"],
  ["IS", "Iceland", "Исландия"],
  ["IN", "India", "Индия"],
  ["ID", "Indonesia", "Индонезия"],
  ["IR", "Iran", "Иран"],
  ["IQ", "Iraq", "Ирак"],
  ["IE", "Ireland", "Ирландия"],
  ["IL", "Israel", "Израиль"],
  ["IT", "Italy", "Италия"],
  ["JM", "Jamaica", "Ямайка"],
  ["JP", "Japan", "Япония"],
  ["JO", "Jordan", "Иордания"],
  ["KZ", "Kazakhstan", "Казахстан"],
  ["KE", "Kenya", "Кения"],
  ["KI", "Kiribati", "Кирибати"],
  ["KP", "North Korea", "КНДР"],
  ["KR", "South Korea", "Южная Корея"],
  ["KW", "Kuwait", "Кувейт"],
  ["KG", "Kyrgyzstan", "Кыргызстан"],
  ["LA", "Laos", "Лаос"],
  ["LV", "Latvia", "Латвия"],
  ["LB", "Lebanon", "Ливан"],
  ["LS", "Lesotho", "Лесото"],
  ["LR", "Liberia", "Либерия"],
  ["LY", "Libya", "Ливия"],
  ["LI", "Liechtenstein", "Лихтенштейн"],
  ["LT", "Lithuania", "Литва"],
  ["LU", "Luxembourg", "Люксембург"],
  ["MO", "Macau", "Макао"],
  ["MG", "Madagascar", "Мадагаскар"],
  ["MW", "Malawi", "Малави"],
  ["MY", "Malaysia", "Малайзия"],
  ["MV", "Maldives", "Мальдивы"],
  ["ML", "Mali", "Мали"],
  ["MT", "Malta", "Мальта"],
  ["MH", "Marshall Islands", "Маршалловы Острова"],
  ["MR", "Mauritania", "Мавритания"],
  ["MU", "Mauritius", "Маврикий"],
  ["MX", "Mexico", "Мексика"],
  ["FM", "Micronesia", "Микронезия"],
  ["MD", "Moldova", "Молдова"],
  ["MC", "Monaco", "Монако"],
  ["MN", "Mongolia", "Монголия"],
  ["ME", "Montenegro", "Черногория"],
  ["MA", "Morocco", "Марокко"],
  ["MZ", "Mozambique", "Мозамбик"],
  ["MM", "Myanmar", "Мьянма"],
  ["NA", "Namibia", "Намибия"],
  ["NR", "Nauru", "Науру"],
  ["NP", "Nepal", "Непал"],
  ["NL", "Netherlands", "Нидерланды"],
  ["NZ", "New Zealand", "Новая Зеландия"],
  ["NI", "Nicaragua", "Никарагуа"],
  ["NE", "Niger", "Нигер"],
  ["NG", "Nigeria", "Нигерия"],
  ["MK", "North Macedonia", "Северная Македония"],
  ["NO", "Norway", "Норвегия"],
  ["OM", "Oman", "Оман"],
  ["PK", "Pakistan", "Пакистан"],
  ["PW", "Palau", "Палау"],
  ["PS", "Palestine", "Палестина"],
  ["PA", "Panama", "Панама"],
  ["PG", "Papua New Guinea", "Папуа — Новая Гвинея"],
  ["PY", "Paraguay", "Парагвай"],
  ["PE", "Peru", "Перу"],
  ["PH", "Philippines", "Филиппины"],
  ["PL", "Poland", "Польша"],
  ["PT", "Portugal", "Португалия"],
  ["QA", "Qatar", "Катар"],
  ["RO", "Romania", "Румыния"],
  ["RU", "Russia", "Россия"],
  ["RW", "Rwanda", "Руанда"],
  ["KN", "Saint Kitts and Nevis", "Сент-Китс и Невис"],
  ["LC", "Saint Lucia", "Сент-Люсия"],
  ["VC", "Saint Vincent and the Grenadines", "Сент-Винсент и Гренадины"],
  ["WS", "Samoa", "Самоа"],
  ["SM", "San Marino", "Сан-Марино"],
  ["ST", "São Tomé and Príncipe", "Сан-Томе и Принсипи"],
  ["SA", "Saudi Arabia", "Саудовская Аравия"],
  ["SN", "Senegal", "Сенегал"],
  ["RS", "Serbia", "Сербия"],
  ["SC", "Seychelles", "Сейшелы"],
  ["SL", "Sierra Leone", "Сьерра-Леоне"],
  ["SG", "Singapore", "Сингапур"],
  ["SK", "Slovakia", "Словакия"],
  ["SI", "Slovenia", "Словения"],
  ["SB", "Solomon Islands", "Соломоновы Острова"],
  ["SO", "Somalia", "Сомали"],
  ["ZA", "South Africa", "ЮАР"],
  ["SS", "South Sudan", "Южный Судан"],
  ["ES", "Spain", "Испания"],
  ["LK", "Sri Lanka", "Шри-Ланка"],
  ["SD", "Sudan", "Судан"],
  ["SR", "Suriname", "Суринам"],
  ["SE", "Sweden", "Швеция"],
  ["CH", "Switzerland", "Швейцария"],
  ["SY", "Syria", "Сирия"],
  ["TW", "Taiwan", "Тайвань"],
  ["TJ", "Tajikistan", "Таджикистан"],
  ["TZ", "Tanzania", "Танзания"],
  ["TH", "Thailand", "Таиланд"],
  ["TL", "Timor-Leste", "Восточный Тимор"],
  ["TG", "Togo", "Того"],
  ["TO", "Tonga", "Тонга"],
  ["TT", "Trinidad and Tobago", "Тринидад и Тобаго"],
  ["TN", "Tunisia", "Тунис"],
  ["TR", "Türkiye", "Турция"],
  ["TM", "Turkmenistan", "Туркменистан"],
  ["TV", "Tuvalu", "Тувалу"],
  ["UG", "Uganda", "Уганда"],
  ["UA", "Ukraine", "Украина"],
  ["AE", "United Arab Emirates", "ОАЭ"],
  ["GB", "United Kingdom", "Великобритания"],
  ["US", "United States", "США"],
  ["UY", "Uruguay", "Уругвай"],
  ["UZ", "Uzbekistan", "Узбекистан"],
  ["VU", "Vanuatu", "Вануату"],
  ["VA", "Vatican", "Ватикан"],
  ["VE", "Venezuela", "Венесуэла"],
  ["VN", "Vietnam", "Вьетнам"],
  ["YE", "Yemen", "Йемен"],
  ["ZM", "Zambia", "Замбия"],
  ["ZW", "Zimbabwe", "Зимбабве"],
];

/** Convert ISO-3166-1 alpha-2 code to flag emoji using regional indicator symbols. */
export function flagOf(code) {
  if (!code || typeof code !== "string" || code.length !== 2) return "🏳️";
  const upper = code.toUpperCase();
  // Regional Indicator Symbol Letter A = 0x1F1E6, ASCII 'A' = 65
  return String.fromCodePoint(...[...upper].map((c) => 0x1F1E6 + c.charCodeAt(0) - 65));
}

/** Resolve a country object by ISO code (or fallback to {code, en, ru} unknown). */
export function findCountry(code) {
  const c = (code || "").toUpperCase();
  const row = COUNTRIES.find((r) => r[0] === c);
  if (!row) return { code: c || "", en: "Unknown", ru: "—" };
  return { code: row[0], en: row[1], ru: row[2] };
}

/** Build a normalized list: [{code, en, ru, flag}, ...] sorted by ru name. */
export const COUNTRY_OPTIONS = COUNTRIES
  .map(([code, en, ru]) => ({ code, en, ru, flag: flagOf(code) }))
  .sort((a, b) => a.ru.localeCompare(b.ru, "ru"));
